import { useCallback } from 'react';
import { sdk } from 'sdk';
import {
  PaymentMethod,
  PaymentResponse,
  PaymentRequestPayload,
  KlarnaPaymentRequestPayload,
  ClearpayPaymentRequestPayload,
  IdealPaymentRequestPayload,
  PayPalPaymentRequestPayload,
  ApplePayPaymentRequestPayload,
  ApplePaySessionResponse,
  ApplePaySessionRequestPayload,
} from 'components/commercetools-ui/organisms/checkout/provider/payment/types';

const useAdyen = () => {
  const getPaymentMethods = useCallback(async (country: string, locale: string, isUk: boolean) => {
    console.info('getPaymentMethods:' + country + locale + isUk);
    const response = await sdk.callAction({
      actionName: 'adyen/getPaymentMethods',
      payload: {
        country: country,
        locale: locale,
        isUk: isUk,
      },
    });
    return response.isError ? [] : (response.data as PaymentMethod[]);
  }, []);

  const makePayment = useCallback(
    async (
      data:
        | PaymentRequestPayload
        | KlarnaPaymentRequestPayload
        | ClearpayPaymentRequestPayload
        | IdealPaymentRequestPayload
        | PayPalPaymentRequestPayload
        | ApplePayPaymentRequestPayload,
    ) => {
      const response = await sdk.callAction({
        actionName: 'adyen/makePayment',
        payload: data,
      });

      return (response.isError ? {} : response.data) as PaymentResponse;
    },
    [],
  );

  const getApplePaySession = useCallback(async (data: ApplePaySessionRequestPayload) => {
    const response = await sdk.callAction({
      actionName: 'adyen/getApplePaySession',
      payload: data,
    });

    return (response.isError ? {} : response.data) as ApplePaySessionResponse;
  }, []);

  const getPaymentSession = useCallback(async (data: any) => {
    const response = await sdk.callAction({
      actionName: 'adyen/getPaymentSession',
      payload: data,
    });

    return (response.isError ? {} : response.data) as any;
  }, []);

  const paymentDetails = useCallback(async (data: Record<string, string>) => {
    const response = await sdk.callAction({
      actionName: 'adyen/paymentDetails',
      payload: data,
    });

    return (response.isError ? {} : response.data) as PaymentResponse;
  }, []);

  return {
    getPaymentMethods,
    makePayment,
    paymentDetails,
    getApplePaySession,
    getPaymentSession,
  };
};

export default useAdyen;
